module.exports = {
    borderRadius: {
        base: '16px',
        large: '26px',
    },
    colors: {
        black: '#000000',
        lightBlue: '#00b5e2',
        superLightBlue: '#a3daec',
        blue: '#0033a0',
        darkBlue: '#211551',
        superDarkBlue: '#1C1345',
        darkGrey: '#646464',
        lightGrey: '#dcdcdc',
        orange: '#fe5000',
        peach: '#f68d2e',
        lightPeach: '#fdb987',
        success: '#6cc24a',
        error: '#dc2828',
        superLightGrey: '#eeeeee',
        transparent: 'transparent',
        white: '#ffffff',
        almostWhite: '#f8f9fa',
        darkWhite: '#e0e0e0',
        purple: '#72246c',
        lightPink: '#f7ced7',
        pink: '#ff97ae',
    },
    headerHeight: '70px',
    contentMaxWidthExtra: '1440px',
    contentMaxWidth: '1150px',
    maxWidth: 1150,
    formPadding: {
        desktop: '40px',
        mobile: '20px',
    },
    outerPadding: '3.5vw',
    gap: {
        col: '4rem',
        row: '3.75rem',
    },
    baseSize: 16,
    breakpoints: {
        smallSmartphone: 320,
        smartphone: 380,
        bigSmartphone: 480,
        tablet: 768,
    },
    mediaQueries: {
        // Tablet and larger
        tabletMin: '@media only screen and (min-width: 768px)',
        // Only mobile
        mobileMax: '@media only screen and (max-width: 767px)',
        // Desktop and larger
        desktopMin: '@media only screen and (min-width: 1152px)',
    },
    spacing: {
        tiny: '0.5rem' /** 8px */,
        // (smaller is basesize, which is 16px)
        smaller: '1rem' /** 16px */,
        small: '1.5rem' /** 24px */,
        base: '2rem' /** 32px */,
        medium: '3.75rem' /** 60px */,
        large: '4rem' /** 64px */,
        xlarge: '6rem' /** 96px */,
        indent: '2.5rem' /** Indentation spacing. For example on headings */,
    },
    menuBar: {
        height: '80px',
    },
}
